import React, { Component } from "react";
import { connect } from "react-redux";
import { CustomDrawer } from "../../Shared";
import { FullWidthButton, Alert } from "../../Shared";
import PractitionerListItem from "./PractitionerListItem";
import { onPractitionerSelect } from ".././stepHelpers";
import * as STEP_KEYS from "../../../consts";
import { practitionerSelector } from "../../../selectors";
import {
  updateAppointmentDetail,
  toggleControl,
  goToStep,
  goBackToStep,
  completeStep
} from "../../../actions";

class PractitionerDrawer extends Component {
  handlePractitionerSelect = value => {
    this.props.toggleControl(STEP_KEYS.PRACTITIONER, false);

    if (this.props.value === value && !this.props.current) {
      return;
    }
    onPractitionerSelect(this.props, value);
  };

  handleDawerRequestChange = open => {
    this.props.toggleControl(STEP_KEYS.PRACTITIONER, open);
  };

  renderPractitioners = () => {
    if (!this.props.isOpen) return null;
    const self = this;
    if (this.props.options.length === 0) {
      return <Alert message="No practitioner available" />;
    }
    return this.props.options.map(practitioner => {
      const selected = this.props.value === practitioner.practitionerId;
      return (
        <PractitionerListItem
          key={practitioner.practitionerId}
          practitioner={practitioner}
          selected={selected}
          onClick={self.handlePractitionerSelect}
        />
      );
    });
  };

  renderAnyPractitionerButton = () => {
    if (this.props.options.length <= 1) return null;

    return (
      <FullWidthButton
        label="Any available practitioner"
        onClick={() => this.handlePractitionerSelect("ANY")}
      />
    );
  };

  render() {
    return (
      <CustomDrawer
        onRequestChange={this.handleDawerRequestChange}
        open={this.props.isOpen}
      >
        <span className="drawer-title">Select preferred practitioner:</span>
        {this.renderAnyPractitionerButton()}
        <div className="drawer-list">{this.renderPractitioners()}</div>
      </CustomDrawer>
    );
  }
}

export default connect(practitionerSelector, {
  updateAppointmentDetail,
  toggleControl,
  goToStep,
  goBackToStep,
  completeStep
})(PractitionerDrawer);



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Steps/DrawerContent/PractitionerDrawer.js